import { IAlertList } from '../types/IAlert';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export let AlertTarget = {
  datasource: 'datasource',
  workbook: 'workbook'
};

export interface IGetAlertParams {
  targetId: string;
  targetType: string; // AlertTarget
}

export interface IGetAlertResult extends IAlertList {
}

export class GetAlertRequest extends Request<IGetAlertParams, IGetAlertResult> {
  constructor(params: IGetAlertParams) {
    super('getAlert', params);
  }
}
